// extracted by mini-css-extract-plugin
module.exports = {"text-align-center":"common_text-align-center__1xPAJ"};